<template>
  <div >
    <div class="mIndex" v-if="$route.query.letterDetail !== '1'">
      <div class="header">
        <img src="../../../static/assets/mlogo.png" alt />
      </div>

      <section class="email_box">
        <div class="left_box">
          <p class="write_title">校长信箱</p>
          <div class="write_way" @click="toWriteEmail">我要写信</div>
        </div>
        <div class="right_box">
          <p class="write_title">进度查询</p>
          <div class="write_way" @click="jdcx">我的信件</div>
        </div>
      </section>

      <section class="email_show">
        <header>
          <div class="flex-col-center">
            <img src="../../../static/assets/icon_laixin.png" alt />
            <p class="title">来信展示</p>
          </div>
          <div class="title_tip">展示管理员选登公开的信件</div>
        </header>

        <div class="wrapper" v-loading="loading">
          <div
            class="item"
            v-for="item in dataList"
            :key="item.WID"
            @click="openDetail(item.WID)"
          >
            <div class="item_title">
              <div class="dot">●</div>
              <div class="title">{{ item.TITLE }}</div>
            </div>
            <div class="item_info">
              <p>浏览量：{{ item.READNUM }}</p>
              <p>{{ item.CREATE_TIME.substr(0, 10) }}</p>
            </div>
          </div>

          <div class="empty" v-if="dataList && dataList.length == 0">
            <img src="../../../static/assets/empty.png" alt />
            <p>暂无数据</p>
          </div>

          <div class="more" @click="viewMore" v-show="showMore">
            <p>查看更多</p>
            <img src="../../../static/assets/icon_arrow.png" alt />
          </div>
        </div>
      </section>

      <div class="bottom">
        <p>版权信息：© 2016 中南民族大学</p>
      </div>

      <div class="fixed_tel" @click="popupTel = true">
        <img src="../../../static/assets/icon_tel.png" alt />
      </div>

      <mt-popup v-model="popupTel">
        <section class="mask_dialog">
          <header>
            <img src="../../../static/assets/icon_tel.png" alt />
            <p>校园服务电话</p>
          </header>

          <div class="close" @click="popupTel = false">
            <img src="../../../static/assets/cha.png" alt />
          </div>

        <div class="content">
          <p>学校信访办： 67843328</p>
          <p>校园110： 67843110</p>
          <p>学生管理科： 67842955</p>
          <p>心理咨询预约： 67842501</p>
          <p>学生宿管中心： 67842796</p>
          <p>学生资助中心： 67842722</p>
          <p>研究生院： 67842498</p>
          <p>团委（社团活动）： 67841396</p>
          <p>食堂服务： 15927076739</p>
          <p>校园网服务： 67843672</p>
          <p>教室网络设备服务： 67843900</p>
          <p>校园卡服务： 67842559、67841627、87058095（北区）</p>
          <p>校医院急诊： 15802793857</p>
          <p>毕业生就业： 67842082</p>
          <p>毕业生档案： 67841629</p>
          <p>毕业生党组织关系咨询： 6784431</p>
          <p>学校法律援助中心：67843217</p>
          <p>物业服务：87383036（东区）、</p>
          <p>87572081（西区及当代）</p>
        </div>
      </section>
    </mt-popup>
    </div>
    <mdetail v-else></mdetail>
  </div>
</template>
<script>
import * as utils from "../../utils";
import api from "../../api";
import { Indicator } from "bh-mint-ui2";
import mdetail from "../../components/mobileDetail/index.vue"
export default {
  data() {
    return {
      popupTel: false,
      pageSize: 10,
      pageNum: 1,
      dataList: [],
      total: 0,
      loading: false,
    };
  },
  components: {
    Indicator,
    mdetail
  },
  created() {
    this.getData();
    this.getLetterCount();
    sessionStorage.removeItem("personalTab");
  },
  computed: {
    showMore() {
      return this.total > this.pageSize * this.pageNum;
    },
  },
  methods: {
    toWriteEmail() {
      window.open("https://ehall.scuec.edu.cn/oa/sys/newoaydapp/Capacity/mobile.do#/xzxx");
      // window.open(window.myWriteEmailUrl);
    },
    jdcx() {
      sessionStorage.setItem('personalTab', 'wdxj')
      window.open("https://ehall.scuec.edu.cn/oa/sys/newoaydapp/Capacity/mobile.do#/xzxx")
      // window.open(window.jdcxUrl);
    },
    openDetail(id) {
      this.$router.push({
        path: this.$route.path,
        query: {
          WID: id,
          letterDetail: "1",
        },
      });
    },
    viewMore() {
      this.pageNum += 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      utils
        .Get(api.getSelLetterList, {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        })
        .then((res) => {
          let resp = JSON.parse(res.data);
          if (resp.success) {
            // let datas = resp.datas && resp.datas.slice(0, 10);
            let datas = resp.datas;
            this.dataList = [...this.dataList, ...datas];
          } else {
            this.dataList = [];
          }
          // console.log(this.dataList)
          this.loading = false;
        });
    },
    getLetterCount() {
      utils.Get(api.getLetterCount).then((res) => {
        let resp = JSON.parse(res.data);
        this.total = Number(resp.datas[0].allLetterCount) || 0;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mIndex {
  height: calc(100vh - 10rem);
  .header {
    background: url("../../../static/assets/mbg.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 15.5rem;
    position: relative;
    text-align: center;
    z-index: 1;

    img {
      width: 19.75rem;
      height: 3rem;
      margin-top: 1.5rem;
    }
  }

  .email_box {
    position: relative;
    border-radius: 0.75rem 0.75rem 0rem 0rem;
    background: #fff;
    z-index: 2;
    padding: 0.94rem 1rem;
    width: calc(100% - 2rem);
    display: flex;
    align-items: center;
    justify-content: space-between;
    top: -10rem;

    .left_box {
      background: url(../../../static/assets/mjinduchau.png) no-repeat;
      background-size: 100% 100%;
      height: 4.75rem;
      width: 9.63rem;
      padding: 0.75rem 0 0 0.75rem;
    }

    .right_box {
      background: url(../../../static/assets/mxiaozhangxinxiang.png) no-repeat;
      background-size: 100% 100%;
      height: 4.75rem;
      width: 9.63rem;
      padding: 0.75rem 0 0 0.75rem;
    }

    .write_title {
      color: #ffffff;
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 1.13rem;
      line-height: normal;
      letter-spacing: 0rem;
    }

    .write_way {
      color: #262626;
      font-family: PingFang SC;
      font-size: 0.75rem;
      text-align: center;
      width: 4.25rem;
      height: 1.63rem;
      line-height: 1.63rem;
      border-radius: 0.94rem;
      background: rgba(255, 255, 255, 0.9);
      margin-top: 0.5rem;
    }
  }

  .email_show {
    position: relative;
    z-index: 2;
    top: -10rem;
    background: #fff;

    header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 3.75rem;
      width: calc(100% - 2.12rem);
      border-radius: 0.75rem 0.75rem 0rem 0rem;
      background: linear-gradient(
        180deg,
        rgba(230, 237, 255, 0.8) 0%,
        rgba(246, 249, 255, 0.8) 100%
      );
      padding: 0 1.06rem;

      img {
        width: 1.3rem;
      }

      .title {
        font-size: 1.13rem;
        line-height: 1.5rem;
        color: #395eaa;
        font-weight: bold;
        margin-left: 0.38rem;
      }

      .title_tip {
        color: #93a3c6;
        font-size: 0.75rem;
        line-height: 1.13rem;
      }
    }

    .flex-col-center {
      display: flex;
      align-items: center;
    }

    .wrapper {
      padding: 0 1.06rem;
      .item {
        margin-top: 0.75rem;
        border-bottom: 0.03rem solid #12121214;

        &:nth-last-child(3) {
          border-bottom: none;
        }
        .item_title {
          display: flex;
          align-items: flex-start;
          .dot {
            position: relative;
            left: -0.25rem;
            top: 0.25rem;
            font-size: 0.25rem;
            color: #395eaa;
          }

          .title {
            color: #121212;
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 0.94rem;
          }
        }

        .item_info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 0.25rem;
          padding-bottom: 0.63rem;

          p {
            color: #969696;
            font-family: PingFang SC;
            font-size: 0.88rem;
          }
        }
      }
    }

    .more {
      display: flex;
      align-items: center;
      border-radius: 0.5rem;
      background: #f4f8ff;
      height: 2.75rem;
      font-size: 0.88rem;
      line-height: 1.13rem;
      justify-content: center;
      color: #395eaa;

      img {
        margin-left: 0.2rem;
        width: 0.8rem;
      }
    }
  }

  .bottom {
    margin-top: 1.25rem;
    font-size: 0.75rem;
    line-height: 1.13rem;
    text-align: center;
    padding: 0.63rem 0 0.56rem;
    background: #395eaa;
    width: 100%;
    color: rgba(255, 255, 255, 0.89);
    position: relative;
    z-index: 2;
    top: -10rem;
  }

  .fixed_tel {
    position: fixed;
    right: 0.94rem;
    bottom: 8.75rem;
    border-radius: 0.5rem;
    background: #ffffff;
    padding: 0.44rem;
    box-shadow: 0rem 0.13rem 0.5rem 0rem #09115833;
    z-index: 2;
    img {
      width: 1.88rem;
    }
  }

  .mask_dialog {
    background: url(../../../static/assets/mask_bg.png) no-repeat;
    background-size: 100% 100%;
    padding: 1.06rem 1.25rem;
    width: 19.15rem;
    border-radius: 1rem;
    position: relative;
    header {
      display: flex;
      align-items: center;
      img {
        width: 1.5rem;
      }

      p {
        color: #141414;
        font-size: 1.06rem;
        font-weight: bold;
        margin-left: 0.5rem;
      }
    }

    .content {
      color: #444444;
      font-size: 0.88rem;
      line-height: 1.5rem;
      margin-top: 0.75rem;
    }

    .close {
      position: absolute;
      right: 0.88rem;
      top: 1.13rem;

      img {
        width: 1rem;
      }
    }
  }

  .empty {
    text-align: center;
    img {
      width: 20rem;
    }

    p {
      color: #969696;
      font-size: 0.88rem;
    }
  }
}
.mint-popup {
  border-radius: 1rem;
}
</style>



// WEBPACK FOOTER //
// mIndex.vue?1e70f082